import { IdName } from '../models/id-name.model';
import * as _ from 'lodash';
import { IdNameImage } from '../models/id-name-image.model';
import { SafeResourceUrl } from '@angular/platform-browser';

export function enumToList(enumObj, getEnum: (number) => string): Array<IdName> {
  return _.values(enumObj)
    .filter((x: number) => !isNaN(x))
    .map((x: number) => new IdName(x, getEnum(x)));
}

export function enumToImageList(
  enumObj,
  getEnum: (number) => string,
  getImage: (number) => SafeResourceUrl
): Array<IdNameImage> {
  const result = _.values(enumObj)
    .filter((x: number) => !isNaN(x))
    .map((x: number) => new IdNameImage(x, getEnum(x), getImage(x)));

  return result;
}
